import toast from 'react-hot-toast';

/**
 * Show a toast notification
 * @param {string} message - The message to display
 * @param {string} type - The type of toast: 'success', 'error', 'loading', 'info'
 * @param {object} options - Additional options for the toast
 */
export const showToast = (message, type = 'info', options = {}) => {
  const defaultOptions = {
    duration: 4000,
    position: 'top-center',
    className: 'animate-toast-slide-in',
    style: {
      background: 'var(--color-card)',
      color: 'var(--color-foreground)',
      border: '1px solid var(--color-border)',
      borderRadius: '0.75rem',
      padding: '12px 16px',
      fontSize: '14px',
      fontFamily: 'var(--font-interface)',
      boxShadow: '0 4px 12px rgba(155, 141, 199, 0.15)',
    },
    ...options,
  };

  switch (type) {
    case 'success':
      return toast?.success(message, {
        ...defaultOptions,
        icon: '✓',
        iconTheme: {
          primary: 'var(--color-success)',
          secondary: 'var(--color-success-foreground)',
        },
      });

    case 'error':
      return toast?.error(message, {
        ...defaultOptions,
        icon: '✕',
        iconTheme: {
          primary: 'var(--color-destructive)',
          secondary: 'var(--color-destructive-foreground)',
        },
      });

    case 'loading':
      return toast?.loading(message, defaultOptions);

    case 'info':
    default:
      return toast(message, {
        ...defaultOptions,
        icon: 'ℹ',
        iconTheme: {
          primary: 'var(--color-primary)',
          secondary: 'var(--color-primary-foreground)',
        },
      });
  }
};

/**
 * Dismiss a specific toast or all toasts
 * @param {string} toastId - Optional toast ID to dismiss specific toast
 */
export const dismissToast = (toastId) => {
  if (toastId) {
    toast?.dismiss(toastId);
  } else {
    toast?.dismiss();
  }
};

/**
 * Show a promise toast (loading -> success/error)
 * @param {Promise} promise - The promise to track
 * @param {object} messages - Messages for loading, success, and error states
 */
export const showPromiseToast = (promise, messages) => {
  return toast?.promise(
    promise,
    {
      loading: messages?.loading || 'Loading...',
      success: messages?.success || 'Success!',
      error: messages?.error || 'Something went wrong',
    },
    {
      className: 'animate-toast-slide-in',
      style: {
        background: 'var(--color-card)',
        color: 'var(--color-foreground)',
        border: '1px solid var(--color-border)',
        borderRadius: '0.75rem',
        padding: '12px 16px',
        fontSize: '14px',
        fontFamily: 'var(--font-interface)',
        boxShadow: '0 4px 12px rgba(155, 141, 199, 0.15)',
      },
    }
  );
};